var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 2.25H11.75C12.3477 2.25 12.875 2.77734 12.875 3.375V5.625C12.875 6.25781 12.3477 6.75 11.75 6.75H9.5C8.86719 6.75 8.375 6.25781 8.375 5.625V3.375C8.375 2.77734 8.86719 2.25 9.5 2.25ZM2.75 4.5H7.25V6.1875C7.25 7.13672 7.98828 7.875 8.9375 7.875H12.3125C13.2266 7.875 14 7.13672 14 6.1875V4.5H18.5C19.7305 4.5 20.75 5.51953 20.75 6.75V18C20.75 19.2656 19.7305 20.25 18.5 20.25H2.75C1.48438 20.25 0.5 19.2656 0.5 18V6.75C0.5 5.51953 1.48438 4.5 2.75 4.5ZM6.6875 17.6484C6.6875 17.8594 6.82812 18 7.03906 18H14.1758C14.3867 18 14.5625 17.8594 14.5625 17.6484C14.5625 16.5938 13.7188 15.75 12.6641 15.75H8.55078C7.49609 15.75 6.6875 16.5938 6.6875 17.6484ZM10.625 14.625C11.3984 14.625 12.1367 14.2031 12.5586 13.5C12.9453 12.832 12.9453 11.9531 12.5586 11.25C12.1367 10.582 11.3984 10.125 10.625 10.125C9.81641 10.125 9.07812 10.582 8.65625 11.25C8.26953 11.9531 8.26953 12.832 8.65625 13.5C9.07812 14.2031 9.81641 14.625 10.625 14.625Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyAccount);
export default ForwardRef;